module.exports = __webpack_public_path__ + "static/img/female-bg-tr.d79f804c.png";